import React from 'react';
import styled from 'styled-components';
import { Type, screenXsMin, screenSmMax, spacer4, spacer24, spacer16, spacer20, spacer40, spacer72 } from '@spotify-internal/encore-web';
import { ButtonTertiaryAsLink, ImageAspectBox1x1 } from '../../ui';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { transformScaleUp } from '../../utils';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ContentItemWrapper = styled.div.withConfig({
  displayName: "ContentItem__ContentItemWrapper",
  componentId: "q847dk-0"
})(["width:100%;display:flex;flex-direction:row;justify-content:space-between;padding:", " ", ";@media (max-width:", "){padding:", ";flex-direction:column;}"], spacer24, spacer72, screenSmMax, spacer16);
var TextWrapper = styled.div.withConfig({
  displayName: "ContentItem__TextWrapper",
  componentId: "q847dk-1"
})(["padding-left:", ";padding-right:", ";width:60%;display:flex;flex-direction:column;justify-content:center;@media (max-width:", "){padding-left:0px;width:90%;}"], spacer20, spacer40, screenSmMax);
var DetailsWrapper = styled.div.withConfig({
  displayName: "ContentItem__DetailsWrapper",
  componentId: "q847dk-2"
})(["width:20%;display:flex;flex-direction:column;justify-content:center;@media (max-width:", "){width:100%;}"], screenSmMax);
var ImageContainer = styled(ImageAspectBox1x1).withConfig({
  displayName: "ContentItem__ImageContainer",
  componentId: "q847dk-3"
})(["padding:", ";width:15%;min-width:300px;height:auto;display:flex;align-items:center;@media (max-width:", "){display:none;}"], spacer20, screenSmMax);
var MobileDetails = styled.div.withConfig({
  displayName: "ContentItem__MobileDetails",
  componentId: "q847dk-4"
})(["display:none;@media (max-width:", "){padding-top:", ";display:initial;}"], screenSmMax, spacer4);
var DesktopDetails = styled.div.withConfig({
  displayName: "ContentItem__DesktopDetails",
  componentId: "q847dk-5"
})(["@media (max-width:", "){display:none;}"], screenSmMax);
var Title = styled(Type.h1).attrs({
  paddingBottom: '0.75em',
  variant: 'alto'
}).withConfig({
  displayName: "ContentItem__Title",
  componentId: "q847dk-6"
})(["padding-bottom:", ";"], spacer16);
var Description = styled(Type.h1).attrs({
  variant: 'cello'
}).withConfig({
  displayName: "ContentItem__Description",
  componentId: "q847dk-7"
})([""]);
var Dateline = styled(Type.h4).attrs({
  variant: 'cello'
}).withConfig({
  displayName: "ContentItem__Dateline",
  componentId: "q847dk-8"
})([""]);
var Location = styled(Type.h4).attrs({
  variant: 'cello',
  weight: 'bold'
}).withConfig({
  displayName: "ContentItem__Location",
  componentId: "q847dk-9"
})(["padding:0px;"]);
var CTABtn = styled(ButtonTertiaryAsLink).withConfig({
  displayName: "ContentItem__CTABtn",
  componentId: "q847dk-10"
})(["background-color:", ";&&{color:", ";}@media (max-width:", "){width:50%;justify-content:center;}&:hover:not(:disabled),&:active:not(:disabled),&:focus:not(:disabled){color:", ";", ";}"], function (props) {
  return props.theme.cta.background;
}, function (props) {
  return props.theme.cta.text;
}, screenSmMax, function (props) {
  return props.theme.cta.text;
}, transformScaleUp);
var CTAContainer = styled.div.withConfig({
  displayName: "ContentItem__CTAContainer",
  componentId: "q847dk-11"
})(["display:flex;@media (max-width:", "){width:100%;justify-content:center;padding-bottom:", ";}"], screenXsMin, spacer20);
var TRACK_CAT = 'module-ContentItemsList';
export var ContentItem = function ContentItem(hit) {
  var date = hit.date,
      image = hit.image,
      title = hit.title,
      description = hit.description,
      location = hit.location,
      _hit$linkExternal = hit.linkExternal,
      linkExternal = _hit$linkExternal === void 0 ? false : _hit$linkExternal,
      children = hit.children;
  var t = useT();
  var formattedDate = date && formatDate(date);

  if (children) {
    return /*#__PURE__*/_jsx(ContentItemWrapper, {
      "data-testid": "content-item-children",
      children: children
    });
  }

  return /*#__PURE__*/_jsxs(ContentItemWrapper, {
    "data-testid": "content-item",
    children: [/*#__PURE__*/_jsx(ImageContainer, {
      children: image && /*#__PURE__*/_jsx(ContentfulImage, {
        asset: image
      })
    }), /*#__PURE__*/_jsxs(TextWrapper, {
      children: [/*#__PURE__*/_jsxs(MobileDetails, {
        children: [location && /*#__PURE__*/_jsx(Location, {
          children: location
        }), formattedDate && /*#__PURE__*/_jsx(Dateline, {
          children: formattedDate
        })]
      }), /*#__PURE__*/_jsx(Title, {
        children: title
      }), /*#__PURE__*/_jsx(Description, {
        children: description
      })]
    }), /*#__PURE__*/_jsxs(DetailsWrapper, {
      children: [/*#__PURE__*/_jsxs(DesktopDetails, {
        children: [location && /*#__PURE__*/_jsx(Location, {
          children: location
        }), formattedDate && /*#__PURE__*/_jsx(Dateline, {
          "data-testid": "content-item-date",
          children: formattedDate
        })]
      }), hit.url && /*#__PURE__*/_jsx(CTAContainer, {
        children: /*#__PURE__*/_jsx(CTABtn, {
          href: hit.url,
          external: linkExternal,
          track: [TRACK_CAT, "ContentItem Details Link - ".concat(title)],
          children: t('FRODOR_CONTENT_ITEM_DETAILS', 'Details', 'Refers to item or event details')
        })
      })]
    })]
  });
};

function formatDate(date) {
  return new Date("".concat(date, "T12:00:00")).toLocaleDateString(undefined, {
    month: 'long',
    year: 'numeric',
    day: 'numeric'
  });
}